import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Text } from '../../../UI/Text';
import { CloseIconContainer, FormModalContainer, FormModalContent } from '../style';
import { FormContainer, FormItem, Input, AddUsersButton, AddAnotherUserButton } from './style';
import { MembersActionCreators } from '../../../../Store/ActionCreators/MembersActionCreators';

class AddMemberWithEmailModal extends Component {
    state = {
        users: [
            {
                fullname: '',
                email: '',
            },
        ],
    };

    addNewUser = () => {
        const newUser = {
            fullname: '',
            email: '',
        };
        this.setState(prevState => ({ users: [...prevState.users, newUser] }));
    };

    handleUserInputChange = ({ target }, index) => {
        const newUsers = [...this.state.users];
        newUsers[index] = { ...newUsers[index], [target.name]: target.value };

        this.setState({ users: [...newUsers] });
    };

    submit = () => {
        const { users } = this.state;
        const requestUsers = users.filter(user => {
            if (user.fullname !== '' && user.email !== '') return user;
        });
        this.props.inviteMembers(requestUsers, () => this.props.onClose());
    };

    render() {
        const {
            props: { onClose },
            state: { users },
            addNewUser,
            handleUserInputChange,
        } = this;

        return (
            <FormModalContainer>
                <FormModalContent>
                    <Text alignCenter fontSize={22} weight={'bold'}>
                        Add via email
                    </Text>

                    <CloseIconContainer onClick={onClose}>
                        <i className="fas fa-times" />
                    </CloseIconContainer>

                    <FormContainer>
                        {users.map((user, index) => (
                            <FormItem>
                                <Input
                                    onChange={e => handleUserInputChange(e, index)}
                                    value={user.fullname}
                                    name={'fullname'}
                                    placeholder={'Full name'}
                                />
                                <Input
                                    onChange={e => handleUserInputChange(e, index)}
                                    value={user.email}
                                    name={'email'}
                                    placeholder={'Email address'}
                                />
                            </FormItem>
                        ))}
                    </FormContainer>

                    <AddAnotherUserButton onClick={addNewUser}>Add another</AddAnotherUserButton>

                    <AddUsersButton onClick={this.submit}>
                        {users.length === 1 ? 'Add user' : 'Add users'}
                    </AddUsersButton>
                </FormModalContent>
            </FormModalContainer>
        );
    }
}

AddMemberWithEmailModal.defaultProps = {
    onClose: () => {},
};

const mapDispatchToProps = dispatch => ({
    inviteMembers: (membersInfo, callback) =>
        dispatch(MembersActionCreators.inviteMemberByEmailRequest(membersInfo, callback)),
});

export default connect(
    null,
    mapDispatchToProps,
)(AddMemberWithEmailModal);



// WEBPACK FOOTER //
// ./src/UI/Components/Modals/AddMemberWithEmailModal/index.js